import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationListRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-list',
	path: '/jira/ops/teams/:teamId/integrations/list',
	exact: true,
};
